import React, { useState } from "react";
import emailjs from 'emailjs-com';
import Navbar from "../core/Navbar";
import WebFooter from "../components/WebFooter";
import { BottomNav } from "../core/BottomNav";
import { Link } from "react-router-dom";

const Contact = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    number:"",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // const serviceID = 'YOUR_SERVICE_ID';
    // const templateID = 'YOUR_TEMPLATE_ID';
    // const userID = 'YOUR_USER_ID';

    // emailjs.send(serviceID, templateID, {
    //   from_name: formData.name,
    //   from_email: formData.email,
    //   message: formData.message,
    //   to_email: 'saifu@gmail.com'
    // }, userID)
    // .then((response) => {
    //   console.log('SUCCESS!', response.status, response.text);
    //   setSubmitStatus('success');
    //   setFormData({ name: '', email: '', message: '' });
    // })
    // .catch((err) => {
    //   console.log('FAILED...', err);
    //   setSubmitStatus('error');
    // })
    // .finally(() => {
    //   setIsSubmitting(false);
    // });
  };

  return (
    <div>
      <Navbar />
  <div className="contact-container">
    <div style={{boxShadow: "0 8px 24px rgba(0,0,0,0.1)",padding: "30px",marginTop:"67px"}}>
        <h2>Contact Us</h2>
        {submitStatus === 'success' && (
          <div className="alert success">Message sent successfully!</div>
        )}
        {submitStatus === 'error' && (
          <div className="alert error">Failed to send message. Please try again.</div>
        )}
        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="number"
            name="number"
            placeholder="Your Number"
            value={formData.number}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          />
           <div className="form-row">
      <label className="form-checkbox">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={(e) => setIsChecked(e.target.checked)}
        />
        {" "}I am accepted  <Link to="/tandc/terms"> terms and conditions</Link>
      </label>
    </div>
          <button type="submit" className={`form-button ${!isChecked ? "disabled" : ""}`} disabled={!isChecked}>
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
  </div>
      <WebFooter />
      <BottomNav />
    </div>
  );
};

export default Contact;